import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface LandingSection {
  id: string;
  section_key: string;
  title: string;
  subtitle: string;
  content_json: any;
  sort_order: number;
  visible: boolean;
  updated_at: string;
}

export function useLandingSections(page: string = "home") {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["landing_sections", page],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("landing_sections" as any)
        .select("*")
        .eq("page", page)
        .order("sort_order", { ascending: true });
      if (error) throw error;
      return (data as any[]) as LandingSection[];
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const getSection = (key: string) => data?.find((s) => s.section_key === key);

  return { sections: data || [], loading: isLoading, getSection, refetch };
}
